import { Component, inject} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthServiceService } from '../service/auth-service.service';
import { FormsModule } from '@angular/forms';
import { SpinnerComponent } from '../controls/spinner/spinner.component';
import { NavbarComponent } from '../components/User/navbar/navbar.component';
import { CommonServiceService } from '../service/common-service.service';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
// import { ChatbotComponent } from '../controls/chatbot/chatbot.component';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    FormsModule,
    SpinnerComponent,
    NavbarComponent,
    // ChatbotComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'prosol11';
  
  ngOnInit() {
    this.common.getSequenceType();
    const token = localStorage.getItem('authToken');
    const url = window.location.pathname;
    if (!token && url == '/passwordrecovery') {
      this.route.navigate(['/passwordrecovery']);
    } else {
      if (!token) {
        this.route.navigate(['/login']);
      }
    }
  }

  constructor(
    public route: Router,
    public authService: AuthServiceService,
    private common: CommonServiceService,
    private activeRoute: ActivatedRoute,
    public http: HttpClient
  ) {
    const userId = localStorage.getItem('UserId');
    this.route.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects.toLowerCase();

        if (url === '/' || url === '/login') {
          this.authService.logout();
        }
      }
    });

    if (userId) {
      this.authService.loggedIn = true;
      // this.common.loadpage(userId);
    }
  }


private sanitizer = inject(DomSanitizer);
  
  showIframe: boolean = false;
  safeIframeUrl: SafeResourceUrl | null = null;

  // This function will be triggered by the navbar
  receiveIframeUrl(url: string) {
    this.safeIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.showIframe = true;
  }

  closeIframe() {
    this.showIframe = false;
    this.safeIframeUrl = null;
  }

}
